import { createSelector } from 'reselect';
import { updatePlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/command/plan';
import { getMode } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import {
	getPlan,
	getPlanScenarios,
	isMultiScenarioEnabled,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getSystemInfo } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/system';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type {
	MapStateToProps,
	MapDispatchToPropsSimple,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import { connect } from '@atlassian/jira-react-redux';
import type { StateProps, DispatchProps, OwnProps } from './types';
import View from './view';

const getPlanScenariosMemoized = () => createSelector(getPlanScenarios, (res) => res);
const mapStateToPropsFactory: () => MapStateToProps<StateProps> = () => {
	const getPlanScenariosInstance = getPlanScenariosMemoized();
	return (state) => ({
		isMultiScenarioEnabled: isMultiScenarioEnabled(state),
		jiraTitle: getSystemInfo(state).jiraTitle,
		planScenarios: getPlanScenariosInstance(state),
		value: getPlan(state).title,
		mode: getMode(state),
	});
};

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps> = (dispatch) => ({
	onChange: (title: string) => {
		dispatch(updatePlan({ title }));
	},
});

export default connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToPropsFactory,
	mapDispatchToProps,
)(View);
